var DatePickerType;
(function (DatePickerType) {
    DatePickerType["LAST_PERIOD"] = "lastPeriod";
    DatePickerType["MONTH"] = "month";
})(DatePickerType || (DatePickerType = {}));
export default DatePickerType;
